// Utility function to refresh user permissions
// This can be called from the browser console to update permissions

/**
 * Refresh user permissions from the server
 * Call this function from the browser console if you're experiencing permission issues
 */
export const refreshUserPermissions = async () => {
  try {
    console.log('🔄 Refreshing user permissions...');
    
    // Get the API service instance
    const apiService = window.apiService || window.__REACT_DEVTOOLS_GLOBAL_HOOK__?.renderers?.get(1)?.getCurrentFiber()?.memoizedState?.baseQueue?.payload?.apiService;
    
    if (!apiService) {
      console.log('❌ API service not found. Please refresh the page and try again.');
      return false;
    }
    
    // Call the refresh method
    const freshUserData = await apiService.refreshUserData();
    
    if (freshUserData) {
      console.log('✅ User permissions refreshed successfully!');
      console.log('👤 New user data:', freshUserData);
      console.log('🔐 New permissions:', freshUserData.permissions);
      
      // Check if view_tickets permission is now available
      if (freshUserData.permissions.includes('view_tickets')) {
        console.log('✅ view_tickets permission is now available!');
        console.log('💡 You should now be able to view all tickets.');
      } else {
        console.log('❌ view_tickets permission is still missing.');
        console.log('💡 Contact an administrator to add this permission.');
      }
      
      // Force a page refresh to update the UI
      console.log('🔄 Refreshing page to apply new permissions...');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      
      return true;
    } else {
      console.log('❌ Failed to refresh user data');
      return false;
    }
  } catch (error) {
    console.error('❌ Error refreshing permissions:', error);
    return false;
  }
};

/**
 * Alternative method: Clear localStorage and redirect to login
 * Use this if the refresh method doesn't work
 */
export const forceReauthentication = () => {
  console.log('🔄 Force re-authentication...');
  
  // Clear all stored data
  localStorage.clear();
  sessionStorage.clear();
  
  console.log('🧹 Cleared all stored data');
  console.log('🔄 Redirecting to login page...');
  
  // Redirect to login
  window.location.href = '/login';
};

// Make functions available globally for console access
if (typeof window !== 'undefined') {
  window.refreshUserPermissions = refreshUserPermissions;
  window.forceReauthentication = forceReauthentication;
  
  console.log('🔧 Permission refresh utilities loaded!');
  console.log('💡 To refresh permissions, run: refreshUserPermissions()');
  console.log('💡 To force re-login, run: forceReauthentication()');
}
